import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UserDefaultService } from 'src/app/shared/services/user-default.service';

@Component({
  selector: 'app-stock-location-range',
  templateUrl: './stock-location-range.component.html',
  styleUrls: [],
  standalone: false
})
export class StockLocationRangeComponent implements OnInit {
  @Input() from: any = null;
  @Input() to: any = null;

  @Output() readonly fromChange = new EventEmitter();
  @Output() readonly toChange = new EventEmitter();

  constructor(private uds: UserDefaultService) {}

  ngOnInit(): void {
    // Apply default values only if both from and to are empty
    if (!this.from && !this.to) {
      this.uds.getDefaultLocation().subscribe(res => {
        if (res?.code) {
          // Set both from and to to the default location code
          this.from = res.code;
          this.to = res.code;
          // Emit the changes to notify parent components
          this.fromChange.emit(res.code);
          this.toChange.emit(res.code);
        }
      });
    }
  }

  onFromChange(event: any) {
    if(this.from === "NULL" || this.from === "ALL") 
       this.to = null;
      
      this.fromChange.emit(event);
  }

  onToChange(event: any) {
    if(this.to === "NULL" || this.to === "ALL") 
       this.from = null;

      this.toChange.emit(event);
  }
}
